import { FC, useEffect, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSaveAddress } from '../../../../api/apiQueries'
import { CircularProgress, Stack } from '@mui/material'
import { useAtomValue, useSetAtom } from 'jotai'
import { currentLocationChangeAtom, provisioningWorkflowStartedByLocationAtom } from '../../../../atoms'
import { toAddress, toLocationChangeWithAddress } from '../../../address-scheduler/AddressSchedulerFormPage/addressScheduleFormUtils'
import { useSnackbar } from '../../../../hooks/useSnackbar'
import { LoggerName, namedLogger } from '../../../../utils/logger'

const logger = namedLogger(LoggerName.SaveAddress)

export const SaveAddress: FC = () => {
  const { sid: locationId } = useParams()
  const navigate = useNavigate()
  const saveAddress = useSaveAddress()
  const currentLocationChange = toLocationChangeWithAddress(useAtomValue(currentLocationChangeAtom))
  const setProvisioningWorkflowStarted = useSetAtom(provisioningWorkflowStartedByLocationAtom)
  const { toast } = useSnackbar()
  const executed = useRef(false)

  useEffect(() => {
    async function save() {
      if (locationId && currentLocationChange && !executed.current) {
        executed.current = true

        try {
          await saveAddress.mutateAsync({ locationId, address: toAddress(currentLocationChange.address) })
          setProvisioningWorkflowStarted(previousState => ({ ...previousState, [locationId]: true }))
        } catch (error) {
          logger.error(`Failed to save address for location ${locationId}`, error as Error)
          setProvisioningWorkflowStarted(previousState => ({ ...previousState, [locationId]: false }))
          toast('Failed to save address.', { variant: 'error' })
        } finally {
          navigate('..', { replace: true })
        }
      }
    }
    save()
  }, [currentLocationChange, locationId, navigate, saveAddress, setProvisioningWorkflowStarted, toast])

  return (
    <Stack alignItems={'center'} justifyContent={'center'} height={'100%'}>
      <CircularProgress />
    </Stack>
  )
}
